<template>
  <div class="h-full flex flex-col overflow-auto" ref="scrollContainer">
    <TourGuide ref="tourGuideRef" @finish="cancelTour()"></TourGuide>
    <div class="pt-10 pb-7">
      <router-link to="/">
        <div class="flex justify-center items-center">
          <div class="flex">
            <img
              :src="require('/assets/images/logo.png')"
              alt=""
              class="w-5 self-center mr-3"
            />
            <p class="font-bold text-xl">
              {{ $t('navigation.communityStudio') }}
            </p>
          </div>
        </div></router-link
      >
    </div>
    <div v-if="!isSetting">
      <div class="p-3 pb-1">
        <div
          id="tg-navBar-search"
          class="flex hover:bg-white items-center border border-gray-300 shadow-sm rounded-lg px-3 py-2 gap-3 cursor-pointer"
          @click="router.push('/search')"
        >
          <div class="flex-none w-5 h-5 relative">
            <div
              class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            >
              <icon name="magnifying-glass" />
            </div>
          </div>
          <p class="flex-none font-medium">
            {{ $t('navigation.searchButton') }}
          </p>
        </div>
      </div>
      <div
        v-if="
          isAdmin ||
          (basicTemplateList && basicTemplateList.length > 0) ||
          (communityTemplateList && communityTemplateList.length > 0)
        "
        class="mt-5 p-3"
      >
        <p class="text-sm text-gray-600 mx-4 mb-2">
          {{ $t('navigation.badgesSection') }}
        </p>
        <NavButton
          id="tg-navBar-basic"
          v-if="isAdmin || (basicTemplateList && basicTemplateList.length > 0)"
          :label="templateTypeToLabel('Basic', i18n)"
          :showAddButton="true"
          :showSendButton="true"
          @clickNavButton="router.push('/templates/basic')"
          @clickSendButton="router.push('/templates/basic?send=1')"
          @clickAddButton="router.push('/templates/basic?add=1')"
          ><icon name="badge-basic"
        /></NavButton>
        <NavButton
          id="tg-navBar-community"
          v-if="
            isAdmin ||
            (communityTemplateList && communityTemplateList.length > 0)
          "
          :label="templateTypeToLabel('Community', i18n)"
          :showAddButton="true"
          @clickNavButton="router.push('/templates/community')"
          @clickAddButton="router.push('/templates/community?add=1')"
          ><icon name="badge-community"
        /></NavButton>
      </div>
      <div
        v-if="
          isAdmin ||
          (participationTemplateList && participationTemplateList.length > 0) ||
          (ticketTemplateList && ticketTemplateList.length > 0)
        "
        class="p-3"
      >
        <p class="text-sm text-gray-600 mx-4 mb-2">
          {{ $t('navigation.eventsSection') }}
        </p>
        <NavButton
          id="tg-navBar-participation"
          v-if="
            isAdmin ||
            (participationTemplateList && participationTemplateList.length > 0)
          "
          :label="templateTypeToLabel('Participation', i18n)"
          :showAddButton="true"
          :showSendButton="true"
          @clickNavButton="router.push('/templates/participation')"
          @clickSendButton="router.push('/templates/participation?send=1')"
          @clickAddButton="router.push('/templates/participation?add=1')"
          ><icon name="badge-participation"
        /></NavButton>
        <NavButton
          id="tg-navBar-ticket"
          v-if="
            isAdmin || (ticketTemplateList && ticketTemplateList.length > 0)
          "
          :label="templateTypeToLabel('Ticket', i18n)"
          :showAddButton="true"
          :showSendButton="true"
          @clickNavButton="router.push('/templates/ticket')"
          @clickSendButton="router.push('/templates/ticket?send=1')"
          @clickAddButton="router.push('/templates/ticket?add=1')"
          ><icon name="badge-ticket"
        /></NavButton>
      </div>
      <div
        v-if="
          isAdmin ||
          (membershipTemplateList && membershipTemplateList.length > 0) ||
          (roleTemplateList && roleTemplateList.length > 0)
        "
        class="p-3"
      >
        <p class="text-sm text-gray-600 mx-4 mb-2">
          {{ $t('navigation.roleAndAccessSection') }}
        </p>
        <NavButton
          id="tg-navBar-membership"
          v-if="
            isAdmin ||
            (membershipTemplateList && membershipTemplateList.length > 0)
          "
          :label="templateTypeToLabel('Membership', i18n)"
          :showAddButton="false"
          :showSendButton="
            !templateListLoading &&
            membershipTemplateList &&
            membershipTemplateList.length > 0
          "
          @clickNavButton="router.push('/templates/membership')"
          @clickSendButton="router.push('/templates/membership?send=1')"
          @clickAddButton="router.push('/templates/membership?add=1')"
          ><icon name="badge-membership"
        /></NavButton>
        <NavButton
          id="tg-navBar-role"
          v-if="isAdmin || (roleTemplateList && roleTemplateList.length > 0)"
          :label="templateTypeToLabel('Role', i18n)"
          :showAddButton="true"
          :showSendButton="true"
          @clickNavButton="router.push('/templates/role')"
          @clickSendButton="router.push('/templates/role?send=1')"
          @clickAddButton="router.push('/templates/role?add=1')"
          ><icon name="badge-role"
        /></NavButton>
      </div>
      <div v-if="isAdmin && (subIssuers.length > 0 || isSubIssuer)" class="p-3">
        <p class="text-sm text-gray-600 mx-4 mb-2">
          {{ $t('navigation.subCommunities.title') }}
        </p>
        <div
          v-for="subIssuer in subIssuers"
          :key="subIssuer.did"
          class="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-white cursor-pointer"
          @click="switchSubIssuer(subIssuer.did)"
        >
          <img
            :src="subIssuer.profileImage"
            alt=""
            class="w-8 h-8 rounded-full"
          />
          <div>
            <p class="font-medium">{{ subIssuer.name }}</p>
            <p class="text-xs text-gray-500">
              {{ subIssuer.membersCount }}
              {{ $t('navigation.membersTxt') }}
            </p>
          </div>
        </div>
        <p
          v-if="!isSubIssuer"
          class="text-blue-500 font-medium mx-4 mb-2 cursor-pointer mt-2"
          @click="router.push('/settings/sub-communities')"
        >
          <icon name="plus" class="fill-blue-500 w-4 mr-3" />{{
            $t('navigation.subCommunities.seeAllTxt')
          }}
          ({{ subIssuersCount }})
        </p>
        <p
          v-if="isSubIssuer"
          class="font-medium hover:bg-white px-3 py-2 rounded-lg cursor-pointer"
          @click="backToAdminIssuer()"
        >
          <icon name="chevron-left" class="w-4 mr-4" />{{
            $t('navigation.subCommunities.backToAdminTxt')
          }}
        </p>
      </div>
    </div>
    <div v-else>
      <div class="p-3">
        <NavButton
          class="py-5 mb-1.5"
          :label="$t('navigation.settingsButton')"
          @clickNavButton="router.push('/')"
          ><icon name="chevron-left"
        /></NavButton>
        <NavButton
          v-if="isAdmin"
          class="mb-1.5"
          :label="$t('navigation.profileInformationButton')"
          @clickNavButton="router.push('/settings/profile')"
          ><icon name="user-square" class="-ml-1"
        /></NavButton>
        <NavButton
          v-if="isAdmin && isWeb2Connexion && displayAccount"
          class="mb-1.5"
          :label="$t('navigation.accountButton')"
          @clickNavButton="router.push('/settings/account')"
          ><icon name="user" class="-ml-1"
        /></NavButton>
        <NavButton
          v-if="isAdmin && displayAccessRole"
          class="mb-1.5"
          :label="$t('navigation.accessRolesButton')"
          @clickNavButton="router.push('/settings/access')"
          ><icon name="account"
        /></NavButton>
        <NavButton
          v-if="isAdmin && !isSubIssuer && isWeb2Connexion"
          class="mb-1.5"
          :label="$t('navigation.subCommunities.title')"
          @clickNavButton="router.push('/settings/sub-communities')"
          ><icon name="sub-communities"
        /></NavButton>
        <NavButton
          v-if="isAdmin && displayMembers"
          class="mb-1.5"
          :label="$t('navigation.membersButton')"
          @clickNavButton="router.push('/settings/members')"
          ><icon name="users"
        /></NavButton>
        <NavButton
          v-if="isAdmin && displayQuests"
          class="mb-1.5"
          :label="$t('navigation.questsButton')"
          @clickNavButton="router.push('/settings/quests')"
          ><icon name="radio-fill"
        /></NavButton>
        <NavButton
          v-if="isAdmin && displayChannel && currentIssuerInfo?.isKms"
          class="mb-1.5"
          :label="$t('navigation.channelButton')"
          @clickNavButton="router.push('/settings/channel')"
          ><icon name="chat-dots"
        /></NavButton>
        <NavButton
          class="mb-1.5"
          :label="$t('navigation.languageButton')"
          @clickNavButton="router.push('/settings/language')"
          ><icon name="globe"
        /></NavButton>
        <NavButton
          v-if="isAdmin && displayPromote"
          class="mb-1.5"
          :label="$t('navigation.promoteButton')"
          @clickNavButton="router.push('/settings/promote')"
          ><icon name="wavy-check"
        /></NavButton>
        <NavButton
          class="mb-1.5"
          :label="$t('navigation.legalMenuButton')"
          @clickNavButton="extendLegalMenu = !extendLegalMenu"
          ><icon name="notebook"
        /></NavButton>
        <div v-if="extendLegalMenu">
          <p
            @click="router.push('/settings/terms')"
            class="text-sm font-medium pl-11 cursor-pointer mb-3"
          >
            {{ $t('navigation.termsButton') }}
          </p>
          <p
            @click="router.push('/settings/privacy')"
            class="text-sm font-medium pl-11 cursor-pointer mb-3"
          >
            {{ $t('navigation.privacyButton') }}
          </p>
          <p
            @click="router.push('/settings/legal')"
            class="text-sm font-medium pl-11 cursor-pointer mb-3"
          >
            {{ $t('navigation.legalButton') }}
          </p>
          <p
            @click="router.push('/settings/cookies')"
            class="text-sm font-medium pl-11 cursor-pointer mb-3"
          >
            {{ $t('navigation.cookieButton') }}
          </p>
        </div>
        <NavButton
          v-if="currentIssuerInfo && !currentIssuerInfo.adminProfile"
          class="mb-1.5"
          :label="$t('navigation.deleteAccountButton')"
          @clickNavButton="showDeleteConfirmation = true"
          ><icon name="trash-empty"
        /></NavButton>
      </div>
    </div>
    <div class="flex-grow"></div>
    <div v-if="!isSetting" class="p-3">
      <div class="min-h-full">
        <div
          id="tg-navBar-menu"
          class="w-full bottom-0 rounded-xl border p-1"
          :class="extendMenu ? 'bg-white' : 'border-transparent'"
          @mouseenter="(extendMenu = true) && scrollToBottom()"
          @mouseleave="extendMenu = false"
        >
          <div v-if="extendMenu" class="mb-2">
            <p
              @click="disconnectIssuer()"
              class="font-medium hover:bg-gray-light text-blue-800 rounded-lg cursor-pointer px-4 py-2 mt-0.5 mb-1.5"
            >
              <icon
                name="log-out"
                class="stroke-blue-800 fill-transparent mr-2"
              />{{ $t('navigation.logoutButton') }}
            </p>
            <p
              v-if="!isSubIssuer && isWeb2Connexion"
              @click="getSwitchAccountToken()"
              class="font-medium hover:bg-gray-light rounded-lg cursor-pointer px-4 py-2 mt-0.5 mb-1.5"
            >
              <icon
                name="user"
                class="stroke-transparent fill-black ml-0.5 mr-2.5"
              />{{ $t('navigation.switchAccountButton') }}
            </p>
            <p
              @click="showMultiCommunityModal = true"
              class="font-medium hover:bg-gray-light rounded-lg cursor-pointer px-4 py-2 mt-0.5 mb-1.5"
            >
              <icon
                name="layers"
                class="stroke-transparent fill-black mr-2"
              />{{ $t('navigation.newCommunityButton') }}
            </p>
            <router-link
              :to="isAdmin ? '/settings/profile' : '/settings/language'"
              ><p
                @click="extendMenu = false"
                class="font-medium hover:bg-gray-light rounded-lg cursor-pointer px-4 py-2 mb-1.5"
              >
                <icon name="settings" class="mr-2" />{{
                  $t('navigation.settingsButton')
                }}
              </p></router-link
            >

            <a href="https://support.mydid.com/" target="_blank">
              <p
                class="font-medium hover:bg-gray-light rounded-lg cursor-pointer px-4 py-2 mb-1.5"
              >
                <icon name="info" class="mr-2" />{{
                  $t('navigation.helpButton')
                }}
              </p></a
            >
          </div>
          <div v-if="currentIssuerInfo" class="flex items-center px-4 py-3">
            <div class="relative w-10 h-10 mr-3">
              <img
                v-if="cookies.get('adminProfile')"
                :src="cookies.get('adminProfile').profileImage"
                alt=""
                class="absolute top-0 -left-4 border bg-gray-200 w-10 h-10 rounded-full"
              />
              <img
                :src="currentIssuerInfo.profileImage"
                alt=""
                class="absolute top-0 left-0 border bg-gray-200 w-10 h-10 my-auto rounded-full mr-3"
              />
            </div>
            <div>
              <p class="w-full font-medium break-words line-clamp-1">
                {{ currentIssuerInfo.name }}
              </p>
              <p class="text-xs text-gray-500">
                {{ currentIssuerInfo.membersCount }}
                {{ $t('navigation.membersTxt') }}
              </p>
            </div>

            <div class="grow"></div>
            <p v-if="!extendMenu" class="text-gray-400 text-xl">
              <icon name="unfold-more" class="w-7" />
            </p>
            <p
              v-else
              @click="showMultiCommunityModal = true"
              class="text-gray-400 text-xl cursor-pointer"
            >
              <icon name="plus" class="w-7" />
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-show="showDeleteConfirmation">
      <BasicSmModal @close="showDeleteConfirmation = false">
        <p class="text-center text-lg font-bold mb-8 px-5">
          {{ $t('navigation.deleteTitle') }}
        </p>
        <p class="text-center text-gray-500 mb-4 px-7">
          {{ $t('navigation.deleteTxt') }}
        </p>
        <p class="text-center text-gray-500 mb-5 px-7">
          {{ $t('navigation.typeDeleteTxt') }}
        </p>
        <div class="w-full flex justify-center mb-8">
          <input
            type="text"
            :placeholder="$t('navigation.typeDeletePlaceholder')"
            class="w-52 outline-none border-gray-300 border rounded-lg px-3 pb-2 pt-2 mx-auto"
            v-model="deleteInput"
          />
        </div>
        <div class="flex justify-center gap-4">
          <button
            @click="showDeleteConfirmation = false"
            class="text-sm bg-white border shadow-sm font-medium rounded-lg cursor-pointer py-1.5 px-2.5"
          >
            {{ $t('navigation.deleteCancelButton') }}
          </button>
          <button
            @click="deleteIssuer() && (showDeleteConfirmation = false)"
            class="text-sm bg-red-500 text-white shadow-sm font-medium rounded-lg cursor-pointer py-1.5 px-2.5"
            :class="{
              'pointer-events-none opacity-50': !deleteInputValid,
            }"
          >
            {{ $t('navigation.deleteConfirmButton') }}
          </button>
        </div>
      </BasicSmModal>
    </div>
    <div v-if="waitingSignature">
      <div class="fixed top-0 left-0 w-full h-full z-10">
        <div class="absolute w-full h-full bg-black bg-opacity-20"></div>
      </div>
      <BasicSmModal :noCloseOption="true">
        <div
          v-if="waitingSignature != 'basicLoader'"
          class="justify-center mb-5"
        >
          <Vue3Lottie
            :animationLink="require('/assets/images/loader-app.jpg')"
            :height="160"
            :width="160"
            :speed="0.7"
          />
        </div>
        <div v-else class="justify-center mb-5">
          <Vue3Lottie
            :animationLink="require('/assets/images/loader-round.jpg')"
            :height="100"
            :width="100"
            :speed="1.5"
          />
        </div>
        <p
          v-if="waitingSignature != 'basicLoader'"
          class="text-center text-xl font-bold px-20 mb-1"
        >
          {{ $t('navigation.confirmAccountDeleteTxt') }}
        </p>
        <p
          v-if="waitingSignature != 'basicLoader'"
          class="text-center px-10 mb-4"
        >
          {{ $t('templateCreation.onMydidAppTxt') }}
        </p>
      </BasicSmModal>
    </div>
    <div v-else-if="transactionSuccessful">
      <div class="fixed top-0 left-0 w-full h-full z-10">
        <div class="absolute w-full h-full bg-black bg-opacity-20"></div>
      </div>
      <BasicSmModal @close="transactionSuccessful = false">
        <div class="justify-center mb-5">
          <Vue3Lottie
            :animationLink="require('/assets/images/loader-check.jpg')"
            :height="160"
            :width="160"
            :speed="0.5"
            :loop="false"
          />
        </div>
        <p class="text-center text-xl font-bold px-20 mb-5">
          {{ $t('navigation.deleteSuccessfulTxt') }}
        </p>
      </BasicSmModal>
    </div>
    <div v-else-if="showMultiCommunityModal">
      <div class="fixed top-0 left-0 w-full h-full z-10">
        <div class="absolute w-full h-full bg-black bg-opacity-20"></div>
      </div>
      <BasicSmModal
        @close="showMultiCommunityModal = false"
        :large="true"
        :absoluteClose="true"
      >
        <p class="text-lg text-gray-500">
          {{ $t('navigation.multiCommunity.title') }}
        </p>
        <div class="text-center max-w-[28rem] mx-auto my-5 pt-5">
          <p class="text-lg font-medium">
            {{ $t('navigation.multiCommunity.titleBis') }}
          </p>
          <p class="text-center">
            {{ $t('navigation.multiCommunity.descriptionTxt') }}
          </p>
          <div class="justify-center my-5">
            <Vue3Lottie
              :animationLink="require('/assets/images/loader-buffer.jpg')"
              :height="160"
              :width="160"
              :speed="1"
              :loop="false"
            />
          </div>
          <p class="text-center mb-7">
            {{ $t('navigation.multiCommunity.descriptionTxtBis') }}
          </p>
          <button
            @click="goToSignup()"
            class="text-sm bg-secondary text-white shadow-sm font-medium rounded-lg cursor-pointer py-2 px-20"
          >
            {{ $t('navigation.multiCommunity.button') }}
          </button>
        </div>
      </BasicSmModal>
    </div>
    <div v-else-if="showTourModal">
      <div class="fixed top-0 left-0 w-full h-full z-10">
        <div class="absolute w-full h-full bg-black bg-opacity-20"></div>
      </div>
      <BasicSmModal @close="cancelTour">
        <div class="text-center max-w-[28rem] mx-auto pt-5">
          <p class="text-lg font-medium mb-4">
            {{ $t('tourGuide.welcomeTitle') }}
          </p>
          <p class="text-center">
            {{ $t('tourGuide.welcomeTxt') }}
          </p>
          <div class="justify-center mt-5">
            <Vue3Lottie
              :animationLink="require('/assets/images/loader-dashboard.jpg')"
              :height="160"
              :width="160"
              :speed="1"
              :loop="false"
            />
          </div>
          <div class="flex mt-16">
            <button
              @click="cancelTour"
              class="text-sm w-80 text-gray-500 rounded-lg cursor-pointer py-2"
            >
              {{ $t('tourGuide.skipTour') }}
            </button>
            <div class="w-full"></div>
            <button
              @click="startTour"
              class="text-sm w-80 bg-secondary text-white shadow-sm font-medium rounded-lg cursor-pointer py-2"
            >
              {{ $t('tourGuide.takeTourButton') }}
            </button>
          </div>
        </div>
      </BasicSmModal>
    </div>
  </div>
</template>

<script>
import { ref, inject, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { toChecksumAddress } from 'ethereum-checksum-address';
import '@sjmc11/tourguidejs/src/scss/tour.scss';
import jwt from 'jsonwebtoken';
import NavButton from './NavButton.vue';
import BasicSmModal from './BasicSmModal.vue';
import TourGuide from './TourGuide.vue';
export default {
  setup() {
    const utils = inject('utils');
    const api = inject('api');
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const { t } = useI18n();
    const cookies = inject('cookies');

    const seeMore = ref(false);

    const currentIssuerDid = computed(() => store.getters.getCurrentIssuerDid);
    const currentIssuerInfo = computed(
      () => store.getters.getCurrentIssuerInfo
    );
    const isWeb2Connexion = computed(() => store.getters.isWeb2Connexion);
    const isAdmin = computed(() => store.getters.isAdmin);
    const currentAddress = computed(() => store.getters.getCurrentAddress);
    const connexionEmail = computed(() => store.getters.getConnexionEmail);

    const basicTemplateList = computed(
      () => store.getters.getBasicTemplateList
    );
    const communityTemplateList = computed(
      () => store.getters.getCommunityTemplateList
    );
    const participationTemplateList = computed(
      () => store.getters.getParticipationTemplateList
    );
    const ticketTemplateList = computed(
      () => store.getters.getTicketTemplateList
    );
    const membershipTemplateList = computed(
      () => store.getters.getMembershipTemplateList
    );
    const roleTemplateList = computed(() => store.getters.getRoleTemplateList);
    const templateListLoading = computed(
      () => store.getters.getTemplateListLoading
    );

    const displayQuests = ref(process.env.VUE_APP_DISPLAY_QUESTS === 'true');
    const displayAccount = ref(process.env.VUE_APP_DISPLAY_ACCOUNT === 'true');
    const displayAccessRole = ref(
      process.env.VUE_APP_DISPLAY_ACCESS_ROLE === 'true'
    );
    const displayMembers = ref(process.env.VUE_APP_DISPLAY_MEMBERS === 'true');
    const displayPromote = ref(process.env.VUE_APP_DISPLAY_PROMOTE === 'true');
    const displayChannel = ref(process.env.VUE_APP_DISPLAY_CHANNEL === 'true');

    const showDeleteConfirmation = ref(false);
    const templateTypeToLabel = ref(utils.templateTypeToLabel);
    const i18n = ref(useI18n());
    const deleteInput = ref(null);
    const deleteInputValid = computed(
      () => deleteInput.value == 'delete' || deleteInput.value == 'supprimer'
    );

    const extendMenu = ref(false);
    const showMore = ref(false);
    const scrollContainer = ref(null);
    const showMultiCommunityModal = ref(false);
    const showTourModal = ref(false);
    const tourGuideRef = ref();
    const extendLegalMenu = ref(false);

    const waitingSignature = ref(null);
    const transactionSuccessful = ref(false);

    const subIssuers = ref([]);
    const subIssuersCount = ref(0);
    const isSubIssuer = ref(!!cookies.get('adminToken'));

    const isSetting = computed(() => {
      return route.path.includes('/settings');
    });

    onMounted(() => {
      const tourGuideNav = cookies.get('tourGuideNav');
      if (!tourGuideNav) {
        showTourModal.value = true;
        store.commit('setTourOngoing', true);
      }
      if (currentIssuerDid.value) {
        getSubIssuers();
      }
    });

    async function getSubIssuers() {
      const subIssuerData = (await api.getSubIssuers(1, 4, '', true)).data;
      subIssuers.value = subIssuerData.issuers;
      subIssuersCount.value = subIssuerData.pagination.totalCount;
    }

    async function getSwitchAccountToken() {
      const { token } = (await api.getSwitchAccountToken()).data;
      cookies.remove('token');
      cookies.remove('adminToken');
      cookies.remove('adminProfile');
      router.push(`/auth?token=${token}`);
    }

    function startTour() {
      showTourModal.value = false;

      tourGuideRef.value.start([
        {
          content: t('tourGuide.navTour.basicTxt'),
          title: t('tourGuide.navTour.basicTitle'),
          id: 'tg-navBar-basic',
        },
        {
          content: t('tourGuide.navTour.communityTxt'),
          title: t('tourGuide.navTour.communityTitle'),
          id: 'tg-navBar-community',
        },
        {
          content: t('tourGuide.navTour.participationTxt'),
          title: t('tourGuide.navTour.participationTitle'),
          id: 'tg-navBar-participation',
        },
        {
          content: t('tourGuide.navTour.membershipTxt'),
          title: t('tourGuide.navTour.membershipTitle'),
          id: 'tg-navBar-membership',
        },
        {
          content: t('tourGuide.navTour.roleTxt'),
          title: t('tourGuide.navTour.roleTitle'),
          id: 'tg-navBar-role',
        },
        {
          content: t('tourGuide.navTour.menuTxt'),
          title: t('tourGuide.navTour.menuTitle'),
          id: 'tg-navBar-menu',
        },
      ]);
    }

    function cancelTour() {
      showTourModal.value = false;
      cookies.set('tourGuideNav', 1, -1);
      store.commit('setTourOngoing', false);
    }

    async function disconnectIssuer(signupRedirect) {
      cookies.remove('token');
      cookies.remove('adminToken');
      cookies.remove('adminProfile');

      store.commit('resetIssuerState');
      router.push(signupRedirect ? '/signin?new=1' : '/signin');
    }

    async function deleteIssuer() {
      if (!isWeb2Connexion.value) {
        waitingSignature.value = 'updateProfile';
      } else {
        waitingSignature.value = 'basicLoader';
      }
      api
        .deleteIssuer()
        .then((res) => {
          const { callbackId } = res.data;
          api.waitOperationValidation(callbackId, (event) => {
            if (event.status == 'canceled') {
              waitingSignature.value = null;
            } else if (
              event.status == 'pending' ||
              event.status == 'treating'
            ) {
              cookies.remove('token');
              window.location.href = '/';
            } else if (event.status == 'success') {
              // nothing because async
            } else if (event.status == 'error') {
              waitingSignature.value = null;
              utils.showToastMessageError(t('other.serverError'));
            }
          });
        })
        .catch(() => {
          utils.showToastMessageError(t('other.serverError'));
          waitingSignature.value = null;
        });
    }

    function scrollToBottom() {
      setTimeout(() => {
        if (scrollContainer.value) {
          scrollContainer.value.scrollTop = scrollContainer.value.scrollHeight;
        }
      }, 50);
    }

    async function switchSubIssuer(did) {
      api.switchSubIssuer(did).then((res) => {
        const { token: subToken } = res.data;

        const token = cookies.get('token');
        cookies.set('token', subToken);
        cookies.set('adminToken', token);
        cookies.set('adminProfile', JSON.stringify(currentIssuerInfo.value));

        const decodedToken = jwt.decode(subToken);
        // restore global session
        store.commit('setCurrentIssuerDid', decodedToken.did);
        store.commit('setCurrentAddress', utils.didToAddress(decodedToken.did));
        store.commit('setIsWeb2Connexion', decodedToken.web2);
        store.commit('setConnexionEmail', decodedToken.connexionEmail);
        store.commit('setIsAdmin', !decodedToken.isContributor);
        store.dispatch('getTemplateLists');
        store.dispatch('getIssuerInfo');

        subIssuers.value = [];
        isSubIssuer.value = true;
      });
    }

    async function backToAdminIssuer() {
      const token = cookies.get('adminToken');
      cookies.remove('adminToken');
      cookies.remove('adminProfile');
      cookies.set('token', token);
      isSubIssuer.value = false;

      const decodedToken = jwt.decode(token);
      // restore global session
      store.commit('setCurrentIssuerDid', decodedToken.did);
      store.commit('setCurrentAddress', utils.didToAddress(decodedToken.did));
      store.commit('setIsWeb2Connexion', decodedToken.web2);
      store.commit('setConnexionEmail', decodedToken.connexionEmail);
      store.commit('setIsAdmin', !decodedToken.isContributor);
      store.dispatch('getTemplateLists');
      store.dispatch('getIssuerInfo');

      getSubIssuers();
    }

    async function goToSignup() {
      if (!isWeb2Connexion.value) {
        disconnectIssuer(true);
      }
      api
        .createSignupToken({ connexionEmail: connexionEmail.value })
        .then((res) => {
          const { token } = res.data;

          const { did, connexionEmail: signupConnexionEmail } =
            jwt.decode(token);

          cookies.remove('token');
          cookies.remove('adminToken');
          cookies.remove('adminProfile');

          store.commit('resetIssuerState');
          store.commit(
            'setCurrentAddress',
            toChecksumAddress(utils.didToAddress(did))
          );
          store.commit('setCurrentPublicKeyBase58', did.split(':')[2]);
          cookies.set('token_tmp', token);
          store.commit('setIssuerConnectionDisplay', false);
          store.commit('setIsWeb2Connexion', true);
          store.commit('setConnexionEmail', signupConnexionEmail);
          router.push('/signup?connected=1');
        });
    }

    return {
      isSetting,
      currentIssuerDid,
      currentIssuerInfo,
      seeMore,
      router,
      showDeleteConfirmation,
      templateTypeToLabel,
      i18n,
      disconnectIssuer,
      extendMenu,
      showMore,
      scrollContainer,
      scrollToBottom,
      deleteIssuer,
      deleteInput,
      deleteInputValid,
      waitingSignature,
      transactionSuccessful,
      showMultiCommunityModal,
      showTourModal,
      startTour,
      cancelTour,
      tourGuideRef,
      basicTemplateList,
      communityTemplateList,
      participationTemplateList,
      ticketTemplateList,
      membershipTemplateList,
      roleTemplateList,
      templateListLoading,
      extendLegalMenu,
      isAdmin,
      subIssuers,
      subIssuersCount,
      switchSubIssuer,
      isSubIssuer,
      backToAdminIssuer,
      getSwitchAccountToken,
      isWeb2Connexion,
      cookies,
      displayQuests,
      displayAccount,
      displayAccessRole,
      displayMembers,
      displayPromote,
      goToSignup,
      displayChannel,
    };
  },
  components: { NavButton, BasicSmModal, TourGuide },
};
</script>
